import { stats } from '@/mocks/home';

export default function StatsBar() {
  return (
    <section className="w-full bg-foreground-950">
      <div className="mx-auto w-full px-4 py-8 md:px-6 md:py-10">
        <div className="grid grid-cols-2 gap-6 md:grid-cols-4 md:gap-8">
          {stats.map((item) => (
            <div key={item.id} className="border-l-2 border-accent-500 pl-4">
              <p className="font-heading text-2xl font-black text-accent-400 md:text-4xl">{item.value}</p>
              <p className="mt-1.5 text-xs text-background-50/70 md:text-sm">{item.label}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}